import React, { useEffect, useState } from "react"
import { ErrorBoundary } from "../ErrorBoundary"
import { MerchantHeader } from "./MerchantHeader"
import { SubscriptionPanel } from "./SubscriptionPanel"
import { RevenuePanel } from "./RevenuePanel"
import { EventTimeline } from "./EventTimeline"

// Customer detail (doc 06). Composes the merchant header, subscriptions, revenue,
// and lifecycle timeline from the show JSON (Partners::CustomerDetail).
export default function CustomerDetailApp({ detailPath, indexPath, devStorePath, canFlagDevStore, copy }) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    let active = true
    fetch(detailPath, { headers: { Accept: "application/json" } })
      .then((res) => (res.ok ? res.json() : Promise.reject(res)))
      .then((json) => active && setData(json))
      .catch(() => active && setError(true))
      .finally(() => active && setLoading(false))
    return () => {
      active = false
    }
  }, [detailPath])

  const back = (
    <a href={indexPath} className="text-sm font-medium text-brand-700 dark:text-brand-300 hover:underline">
      ← {copy.back}
    </a>
  )

  if (error) {
    return (
      <ErrorBoundary>
        {back}
        <div className="mt-4 rounded-xl border border-amber-200 dark:border-amber-900/50 bg-amber-50 dark:bg-amber-950/40 p-6">
          <p className="text-sm text-gray-700 dark:text-gray-300">{copy.states.error}</p>
        </div>
      </ErrorBoundary>
    )
  }
  if (loading || !data) {
    return (
      <ErrorBoundary>
        {back}
        <p className="mt-4 text-sm text-gray-400 dark:text-gray-500">{copy.states.loading}</p>
      </ErrorBoundary>
    )
  }

  return (
    <ErrorBoundary>
      {back}
      <div className="mt-4 space-y-6">
        <MerchantHeader
          merchant={data.merchant}
          devStorePath={devStorePath}
          canFlagDevStore={canFlagDevStore}
          onMerchantUpdated={(merchant) => setData((prev) => ({ ...prev, merchant }))}
          copy={copy}
        />
        {data.merchant.is_development_store ? (
          <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-6 text-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">{copy.devStore.dataHidden}</p>
          </div>
        ) : (
          <>
            <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
              <SubscriptionPanel subscriptions={data.subscriptions} copy={copy} />
              <RevenuePanel
                transactions={data.transactions}
                lifetimeNetCents={data.merchant.lifetime_net_cents}
                copy={copy}
              />
            </div>
            <EventTimeline timeline={data.timeline} copy={copy} />
          </>
        )}
      </div>
    </ErrorBoundary>
  )
}
